import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { setTotalMasterList } from "../../../store/actions/actions";
import Loader from "../../../components/Loader/Loader";
import classes from "./Adminmasters.module.css";
import { recordToDataBase, generateWorkingDays } from "../../../funcs/funcs";

import { API_URL } from "../../../utils/api";

class Adminmasters extends Component {
  state = {
    masterNumber: 0,
    masterName: "",
  };

  async componentDidMount() {
    //получаем данные из БД
    try {
      const response = await axios.get(`${API_URL}/masters.json`);

      const data =
        response.data[
          Object.keys(response.data)[Object.keys(response.data).length - 1]
        ];

      //записываем данные в Редакс
      this.props.setTotalMasterList(data);

      //удаляем лишние записи
      for (let i = 0; i < Object.keys(response.data).length - 1; i++) {
        await axios.delete(
          `${API_URL}/masters/${Object.keys(response.data)[i]}.json`
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  masterChangeHandler = (e) => {
    e.preventDefault();

    this.setState({
      masterNumber: e.target.name,
    });
  };

  //обработчик смены имени и фото мастера
  masterDataChangeHandler = async (e) => {
    e.preventDefault();

    this.setState({
      masterName: e.target.value,
    });

    //клонируем состояние
    const clone = this.props.masterList.slice();

    //меняем имя мастера
    clone[this.state.masterNumber].splice(e.target.name, 1, e.target.value);

    //записываем данные в Редакс
    this.props.setTotalMasterList(clone);
  };

  //обработчик смены перечня услуг для мастера
  offerChangeHandler = (e) => {
    e.preventDefault();

    //клонируем состояние
    const clone = this.props.masterList.slice();

    clone[this.state.masterNumber][2][e.target.name].splice(
      3,
      1,
      !clone[this.state.masterNumber][2][e.target.name][3]
    );

    //записываем данные в Редакс
    this.props.setTotalMasterList(clone);

    //это надо проверить
    setTimeout(() => {
      document
        .querySelectorAll(`.${classes.Adminmasters_names_button}`)
        [this.state.masterNumber].click();
    }, 1);
  };

  //создание нового мастера
  masterCreateHandler = (e) => {
    e.preventDefault();

    //клонируем состояние
    const clone = this.props.masterList.slice();

    //клонируем массив услуг
    const cloneArr = [];

    for (let i = 0; i < clone[0][2].length; i++) {
      cloneArr.push([
        clone[0][2][i][0],
        clone[0][2][i][1],
        clone[0][2][i][2],
        false,
      ]);
    }

    //создаем нового мастера
    clone.push([
      "Default name",
      "Default photo",
      cloneArr,
      generateWorkingDays(),
    ]);

    //записываем данные в Редакс
    this.props.setTotalMasterList(clone);
  };

  masterDeleteHandler = (e) => {
    e.preventDefault();

    //клонируем состояние
    const clone = this.props.masterList.slice();

    clone.splice(this.state.masterNumber, 1);

    this.setState({
      masterNumber: 0,
    });

    //записываем данные в Редакс
    this.props.setTotalMasterList(clone);
  };

  saveChangesHandler = (e) => {
    e.preventDefault();
    //записываем в БД
    recordToDataBase(this.props.masterList);
  };

  render() {
    return (
      <>
        {this.props.masterList.length === 0 ? (
          <Loader />
        ) : (
          <div className={classes.Adminmasters}>
            <h1>Modificare barbiere</h1>
            <div className={classes.Adminmasters_block}>
              <div className={classes.Adminmasters_names}>
                {this.props.masterList.map((master, index) => {
                  return (
                    <input
                      onClick={this.masterChangeHandler}
                      readOnly
                      className={classes.Adminmasters_names_button}
                      key={index}
                      name={index}
                      type="button"
                      value={master[0]}
                    />
                  );
                })}
                <input
                  onClick={this.masterCreateHandler}
                  className={classes.Adminmasters_names_button}
                  type="button"
                  value="+"
                />
              </div>
              <div className={classes.Adminmasters_display}>
                <div className={classes.Adminmasters_display_item}>
                  <span>Elimina barbiere:</span>
                  <input
                    disabled={this.props.masterList.length > 1 ? false : true}
                    onClick={this.masterDeleteHandler}
                    value="Eliminare"
                    type="button"
                    style={{
                      backgroundColor: "red",
                      borderRadius: "5px",
                      color: "white",
                      fontSize: "20px",
                    }}
                  />
                </div>
                <hr />
                <div className={classes.Adminmasters_display_item}>
                  <span>Nome:</span>
                  <input
                    onChange={this.masterDataChangeHandler}
                    name="0"
                    value={this.props.masterList[this.state.masterNumber][0]}
                    type="text"
                  />
                </div>
                <hr />
                <div className={classes.Adminmasters_display_item}>
                  <span>Link:</span>
                  <input
                    onChange={this.masterDataChangeHandler}
                    name="1"
                    type="text"
                    value={this.props.masterList[this.state.masterNumber][1]}
                  />
                </div>
                <div className={classes.Adminmasters_display_item}>
                  <span>P.S. La foto dovrebbe essere quadrata.</span>
                </div>
                <hr />
                <div className={classes.Adminmasters_display_item}>
                  <span>Foto:</span>{" "}
                  <img
                    src={this.props.masterList[this.state.masterNumber][1]}
                    alt="master_face"
                  />{" "}
                </div>
                <hr />
                <div className={classes.Adminmasters_display_offers}>
                  <h4>Elenco dei servizi:</h4>
                  {this.props.masterList[this.state.masterNumber][2].map(
                    (item, index) => {
                      return (
                        <label key={index}>
                          <span>{item[0]}</span>{" "}
                          <input
                            name={index}
                            type="checkbox"
                            onChange={this.offerChangeHandler}
                            checked={item[3]}
                          />{" "}
                        </label>
                      );
                    }
                  )}
                </div>
                <div className={classes.Adminmasters_send_block}>
                  <button
                    onClick={this.saveChangesHandler}
                    className={classes.Adminmasters_send}
                  >
                    Salvare
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    masterList: state.masterList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setTotalMasterList: (arr) => dispatch(setTotalMasterList(arr)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Adminmasters);
